import { PriorityHigh } from '@mui/icons-material'
import {
  Alert,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Expansible } from 'components/Expansible'
import _ from 'lodash'
import React from 'react'
import { correctServiceName } from 'utils/constants/correctedServiceNames'

const SkippedProcessCourtsRelation = ({ processData }) => {
  if (_.isEmpty(processData?.skipped_or_replaced_courts)) {
    return null
  }

  const courts = processData.skipped_or_replaced_courts

  const useStyles = makeStyles({
    container: {
      display: 'flex',
      flexFlow: 'column wrap',
      gap: '0 30px',
      maxHeight: 320,
      marginBottom: 30,
      overflow: 'auto',
    },
    item: {
      width: 'auto',
    },
  })
  const classes = useStyles()

  const courtColor = (courtName) => {
    const process = processData.processes.find(
      (p) => p.court_description === courtName,
    )

    return process?.risk_of_homonymy ? 'orange' : null
  }

  return (
    <div style={{ width: '100%' }}>
      <Expansible open={true} title="Tribunais fora do ar">
        <Alert severity="error" sx={{ fontSize: '1.4rem' }}>
          Os seguintes tribunais não responderam devido a uma instabilidade ou
          porque estão fora do ar. Leve isso em consideração ao analisar os
          processos desta pessoa:
        </Alert>
        <br></br>
        <div className={classes.container}>
          {courts.map((court) => (
            <ListItem className={classes.item} key={court}>
              <ListItemIcon>
                <PriorityHigh style={{ color: courtColor(court) }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '1.4rem' }}
                primary={correctServiceName(court)}
              />
            </ListItem>
          ))}
        </div>

        <Divider></Divider>

        <div style={{ marginTop: 10 }}>
          <Typography sx={{ fontSize: '1.4rem' }}>Legenda: </Typography>
          <br></br>
          <ListItem>
            <ListItemIcon>
              <PriorityHigh />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.4rem' }}
              primary="Nenhuma informação foi obtida do tribunal"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <PriorityHigh style={{ color: 'orange' }} />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.4rem' }}
              primary="Informações parciais obtidas da consulta por nome ao Diário da Justiça (pode haver homônimos)"
            />
          </ListItem>
        </div>
      </Expansible>
    </div>
  )
}

export default SkippedProcessCourtsRelation
